function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base/index';
import { valueType, optionListType } from '../base/types';
import Icon from '../Icon';
import Popup from '../Popup';
import EventBlackHole from '../EventBlackHole';
import Option from '../Select/Option';
import Search from '../Search';
import './style.less';
import { outerHeight } from '../utils';

var SearchSelect = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(SearchSelect, _KZUIComponent);

  var _super = _createSuper(SearchSelect);

  function SearchSelect(props) {
    var _this;

    _classCallCheck(this, SearchSelect);

    _this = _super.call(this, props);

    _this.autoBind('handleSelect', 'handleClick', 'handleBlur', 'handleSearch', 'handleSearchTextChange', 'getPopup' // 'handlePopupUpdate',
    );

    return _this;
  }

  _createClass(SearchSelect, [{
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      var selectedText = props.defaultText;
      var value = props.value;
      var selected = props.options.filter(function (item) {
        if (item.selected || item.value === props.value) {
          return item;
        }

        return undefined;
      });

      if (selected.length > 0) {
        selectedText = selected[0].text;
        value = selected[0].value;
      }

      var searchText = this.state ? this.state.searchText : '';
      var expand = this.state ? this.state.expand : false;
      var dimensions = this.state ? this.state.dimensions : {};
      var checkEmpty = this.state ? this.state.checkEmpty : false;
      return {
        value: value,
        selectedText: selectedText,
        searchText: searchText,
        expand: expand,
        dimensions: dimensions,
        checkEmpty: checkEmpty
      };
    }
  }, {
    key: "getPopup",
    value: function getPopup(clsPrefix) {
      var _this2 = this;

      var _this$state = this.state,
          searchText = _this$state.searchText,
          value = _this$state.value,
          checkEmpty = _this$state.checkEmpty;
      var _this$props = this.props,
          contentMaxHeight = _this$props.contentMaxHeight,
          options = _this$props.options,
          emptyWarning = _this$props.emptyWarning;

      var _this$wrp$getBounding = this.wrp.getBoundingClientRect(),
          x = _this$wrp$getBounding.x,
          y = _this$wrp$getBounding.y,
          width = _this$wrp$getBounding.width,
          height = _this$wrp$getBounding.height;

      var style = {
        left: x,
        top: y + height + 1,
        height: contentMaxHeight,
        width: width
      };
      return /*#__PURE__*/React.createElement(Popup, {
        style: style
      }, /*#__PURE__*/React.createElement(EventBlackHole, {
        className: "".concat(clsPrefix, "-options"),
        captureEvents: ['click']
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.storeRef('popup')
      }, /*#__PURE__*/React.createElement(Search, {
        className: "".concat(clsPrefix, "-search-input"),
        name: "search-text",
        value: searchText,
        onSearch: this.handleSearch,
        onChange: this.handleSearchTextChange
      }), options.map(function (option) {
        return /*#__PURE__*/React.createElement(Option, {
          key: "option-".concat(option.value),
          value: option.value,
          selected: value === option.value,
          onClick: _this2.handleSelect
        }, option.text);
      }), !options.length && checkEmpty ? /*#__PURE__*/React.createElement(Option, {
        value: 0
      }, emptyWarning) : null)));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this3 = this;

      var wrp = this.wrp; // const offset = wrp.offset();

      var dimensions = {
        left: 0,
        top: outerHeight(wrp) + 5,
        width: '100%',
        height: 'auto'
      };
      this.wrp.focus();
      this.setState({
        dimensions: dimensions,
        expand: !this.state.expand
      }, function () {
        if (_this3.state.expand && _this3.props.onExpand) {
          _this3.props.onExpand();
        }
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (e.relatedTarget) {
        if (this.wrp.contains(e.relatedTarget) || this.popup.contains(e.relatedTarget)) {
          e.preventDefault();
          return;
        }
      }

      this.setState({
        expand: false
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(selected) {
      this.setState({
        selectedText: selected.text,
        value: selected.value,
        expand: false
      });

      if (this.props.onChange) {
        this.props.onChange({
          name: this.props.name,
          value: selected.value,
          selectedText: selected.text,
          text: selected.text
        });
      }
    }
  }, {
    key: "handleSearch",
    value: function handleSearch(_ref) {
      var _this4 = this;

      var name = _ref.name,
          value = _ref.value;

      if (this.props.onSearch) {
        this.props.onSearch({
          name: name,
          value: value
        });
      }

      setTimeout(function () {
        _this4.setState({
          checkEmpty: true
        });
      }, 1000);
    }
  }, {
    key: "handleSearchTextChange",
    value: function handleSearchTextChange(_ref2) {
      var value = _ref2.value;
      this.setState({
        checkEmpty: false,
        searchText: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var clsPrefix = 'kui-select';
      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style,
          disabled = _this$props2.disabled,
          size = _this$props2.size;
      var expand = this.state.expand;
      var cls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "__expand"), expand), _defineProperty(_classNames, "".concat(clsPrefix, "__disabled"), disabled), _defineProperty(_classNames, "".concat(clsPrefix, "__with-search"), true), _defineProperty(_classNames, "".concat(clsPrefix, "__").concat(size), !!size), _classNames), className);
      return /*#__PURE__*/React.createElement("div", {
        ref: this.storeRef('wrp'),
        className: cls,
        style: style,
        role: "button",
        tabIndex: 0,
        onClick: this.handleClick,
        onBlur: this.handleBlur
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--selected")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--indicator")
      }, /*#__PURE__*/React.createElement(Icon, {
        iconClass: "kz-e-nav-pull-down"
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--title")
      }, this.state.selectedText)), expand && this.getPopup(clsPrefix));
    }
  }]);

  return SearchSelect;
}(KZUIComponent);

SearchSelect.defaultProps = {
  defaultText: '请选择',
  emptyWarning: '暂无搜索结果',
  value: null,
  name: '',
  options: [],
  onChange: null,
  onSearch: null,
  disabled: false,
  size: '',
  onExpand: null
};
SearchSelect.propTypes = {
  defaultText: PropTypes.string,
  emptyWarning: PropTypes.string,
  name: PropTypes.string,
  value: valueType,
  size: PropTypes.string,
  options: optionListType,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  disabled: PropTypes.bool,
  onExpand: PropTypes.func
};
export default SearchSelect;